import styled from 'styled-components';

const BorderArrowUp = styled.div`
  position: absolute;
  bottom: 0;
  height: 0;
  width: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid black;
  content: '';
  left: 50%;
  transform: translateX(-50%);
  top: -10px;

  &:after {
    position: absolute;
    bottom: 0;
    height: 0;
    width: 0;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    border-bottom: 9px solid white;
    content: '';
    left: 50%;
    transform: translateX(-50%);
    top: 1px;
  }
`;

export default BorderArrowUp;
